import {FC} from 'react';
import {useDispatch} from 'react-redux';

// Store
import {createShare} from 'store/shares-service/asyncActions';

// Components
import StarButton from 'shared/components/StarButton';
import {AvaType} from 'store/ava-service/interfaces';

import s from './CapitalSources.module.scss';

type CapitalSourcesItemProps = {
  ava: AvaType;
  name: string;
  projectSym: string;
  providerSym: string;
  type?: string;
  isSaved?: boolean;
  isMatched?: boolean;
  invited?: boolean;
  shareSyms: Array<string>;
  setShareSyms: (shareSyms: Array<string>) => void;
};

const CapitalSourcesItem: FC<CapitalSourcesItemProps> = ({
  ava,
  name,
  projectSym,
  providerSym,
  type,
  isSaved,
  isMatched,
  invited,
  shareSyms,
  setShareSyms,
}) => {
  const dispatch = useDispatch();

  const handleProviderSave = () => {
    dispatch(createShare({ava, projectSym, providerSym}));
  };

  const handleShareSelect = (sym: string) => {
    if (shareSyms.includes(sym)) {
      setShareSyms(shareSyms.filter((shareSym) => shareSym !== sym));
    } else {
      setShareSyms([...shareSyms, sym]);
    }
  };

  return (
    <>
      {isSaved && !isMatched ? (
        <div className={s.capitalSources__item}>
          <input
            type="checkbox"
            disabled={invited}
            name=""
            id=""
            checked={shareSyms.includes(providerSym)}
            className={s.capitalSources__selected}
            onClick={(e) => e.stopPropagation()}
            onChange={() => handleShareSelect(providerSym)}
          />
          <p className={s.capitalSources__name}>{name}</p>
          <small className={s.capitalSources__type}>
            <i> {type} </i>
          </small>
        </div>
      ) : (
        <div className={s.capitalSources__item}>
          <StarButton handleClick={handleProviderSave} />
          <p className={s.capitalSources__name}>{name}</p>
          <small className={s.capitalSources__type}>
            <i> {type} </i>
          </small>
        </div>
      )}
    </>
  );
};

export default CapitalSourcesItem;
